import { render } from "./ComponenteSimulacion.vue?vue&type=template&id=120babf3&scoped=true"
import script from "./ComponenteSimulacion.vue?vue&type=script&lang=js"
export * from "./ComponenteSimulacion.vue?vue&type=script&lang=js"

import "./ComponenteSimulacion.vue?vue&type=style&index=0&id=120babf3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120babf3"]])

export default __exports__